import { isNumberLike } from "@/utils/common";
import { subtract, multiply, divide } from "@/utils/count";
export default {
  methods: {
    /**
     * 通用手机号校验规则
     * 匹配格式: "前缀-号码" (例如: 86-13800138000)
     */
    validatePhone(rule, value, callback) {
      const isRequired = rule.required;
      // 1. 处理完全为空的情况
      if (value === null || value === undefined || value.trim() === "") {
        return isRequired ? callback(new Error(this.$t("common.placeholder.enter"))) : callback();
      }
      // 2. 拆分数据（格式固定为 "前缀-号码"）
      const [prefix, code] = value.split("-");
      // 排除号码可能为0的情况
      const hasCode = code !== undefined && code !== null && code.trim() !== "";

      // 情况 A：有号码，没有前缀 (value 是 "-123456")
      if (!prefix && hasCode) {
        return callback(new Error(this.$t("common.placeholder.prefix")));
      }
      // 情况 B：有前缀，没有号码 (value 是 "86-")
      if (prefix && !hasCode) {
        // 必填模式下报错，非必填模式下允许通过
        return isRequired ? callback(new Error(this.$t("common.placeholder.enter"))) : callback();
      }
      // 情况 C：没有前缀，没有号码 (value 是 "-")
      if (!prefix && !hasCode) {
        // 必填模式下报错，非必填模式允许通过
        return isRequired ? callback(new Error(this.$t("common.placeholder.enter"))) : callback();
      }
      // 情况 D：前缀和号码都有，进行深度校验
      if (prefix && hasCode) {
        // 【新增】数字校验：检查号码部分是否为纯数字
        const numReg = /^\d+$/;
        if (!numReg.test(code)) {
          return callback(new Error(this.$t("common.regular.phone")));
        }
      }
      // 校验通过
      callback();
    },
    /**
     * 出生日期校验规则
     * 匹配格式: "yyyy-MM-dd" (例如: 2023-01-01)
     */
    validateBirthday(rule, value, callback) {
      const isRequired = rule.required;
      // 1. 处理完全为空的情况
      if (!value || value === "") {
        return isRequired ? callback(new Error(this.$t("common.placeholder.select"))) : callback();
      }
      // 2. 校验是否成年(满18岁)
      const birthDaySecond = new Date(value).getTime();
      const currentDateSecond = new Date().getTime();
      const differenceSecond = subtract(currentDateSecond, birthDaySecond);
      const differenceYear = divide(differenceSecond, multiply(365, 24, 3600, 1000));
      if (differenceYear < 18) return callback(new Error(this.$t("common.placeholder.nonage")));
      // 校验通过
      callback();
    },
    /**
     * 通用货币金额校验规则
     * 匹配格式: "货币 金额" (例如: SGD 13.00, 中间空格不能省略)
     */
    validateCurrencyAmount(rule, value, callback) {
      const isRequired = rule.required;
      // 1. 处理完全为空的情况
      if (value === null || value === undefined || value.trim() === "") {
        return isRequired ? callback(new Error(this.$t("common.placeholder.enter"))) : callback();
      }
      // 2. 拆分数据（格式固定为 "货币 金额"）
      const [currency, amount] = value.split(" ");
      // 排除金额可能为0的情况
      const hasAmount = amount !== undefined && amount !== null && amount.trim() !== "";

      // 情况 A：有金额，没有货币 (value 是 " 13.00")
      if (!currency && hasAmount) {
        return callback(new Error(this.$t("common.placeholder.selectCurrency")));
      }
      // 情况 B：有货币，没有金额 (value 是 "SGD ")
      if (currency && !hasAmount) {
        // 必填模式下报错，非必填模式下允许通过
        return isRequired ? callback(new Error(this.$t("common.placeholder.enter"))) : callback();
      }
      // 情况 C：没有货币，没有金额 (value 是 " ")
      if (!currency && !hasAmount) {
        // 必填模式下报错，非必填模式允许通过
        return isRequired ? callback(new Error(this.$t("common.placeholder.enter"))) : callback();
      }
      // 情况 D：货币和金额都有，进行深度校验
      if (currency && hasAmount) {
        // 【新增】数字校验：检查金额部分是否为数字或字符串数字
        if (!isNumberLike(amount)) {
          return callback(new Error(this.$t("common.regular.amount")));
        }
      }
      // 校验通过
      callback();
    },
    /**
     * 必须勾选的复选框校验规则
     * 匹配格式: true或false, 1或0
     * 使用场景: 勾选协议或同意条款
     */
    validateMustCheckbox(rule, value, callback) {
      const isRequired = rule.required;
      const isChecked = value === true || value === 1 || value === "1";
      if (!isChecked) {
        if (isRequired) {
          return callback(new Error(this.$t("common.placeholder.check")));
        }
        return callback();
      }
      callback();
    },
    /**
     * CheckboxGroupWithOther 校验规则
     * 匹配格式: Array<string | {k: string, v: string}>
     * 示例: ["Savings from employment", { k: "Others, please specify", v: "aaaaa" }]
     * 使用场景: 带 other 补充输入的 checkbox 多选组
     */
    validateCheckboxGroupWithOther(rule, value, callback) {
      const isRequired = rule.required;
      console.log(isRequired, value);
      // 1. 非数组或空数组 → 必填时报错
      if (!Array.isArray(value) || value.length === 0) {
        return isRequired ? callback(new Error(this.$t("common.placeholder.select"))) : callback();
      }
      // 2. 遍历检查 other 项的 v 是否填写
      for (const item of value) {
        if (item && typeof item === "object" && item.k && (!item.v || !String(item.v).trim())) {
          callback(new Error(this.$t("common.placeholder.specify")));
          return;
        }
      }
      // 校验通过
      callback();
    },
  },
};
